import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomDropdown } from '../../../common/custom-form/custom-dropdown.component';
import { TRANSLATIONS } from '../../../../utils/constant.utils';
import { TabberButton } from '../../../common/custom-form/tabber-button.component';
import { CustomMultiSelect } from '../../../common/custom-form/custom-multi-select.component';
import { SelectFieldFloatingLabel as Select } from '../../../common/custom-form/select-filter.component';
import { Button } from "react-bootstrap";
import UploadButton from '../../../common/upload-button/upload-button';
import Translation from '../../../common/translation/translation.component';
import TableWithButton from '../../../common/details-table/table-with-button.component';
import { NotificationModal } from '../../../common/modal/notification-modal.component';
import { KyberConfigActions } from '../../../../store/common/chatbot/kyberconfig/kyberconfig.reducer';
// remove this once API implemented
const SAMPLE_VENDOR_OPTIONS = [
    { Key: '1', Value: 'AT&T' },
    { Key: '2', Value: 'Verizon' },
    { Key: '3', Value: 'T-Mobile' },
    { Key: '4', Value: 'Comcast' },
    { Key: '5', Value: 'Lumen' },
];


// remove this once API implemented
// const SAMPLE_STATUS_OPTIONS = [
//     { Key: '1', Value: 'Active' },
//     { Key: '2', Value: 'Inactive' },
//     { Key: '3', Value: 'Pending' },
//     { Key: '4', Value: 'Disconnected' },
// ];
const SMART_PICK_OPTIONS = [
    { Key: 'true', Value: 'Yes' },
    { Key: 'false', Value: 'No' },
];

// remove this once API implemented
const SAMPLE_TABLE_HEADER = [
    {
        Filename: { propName: 'Filename', name: 'Filename', order: 0, hidden: false },
        UploadDate: { propName: 'UploadDate', name: 'Upload Date', order: 1, hidden: false },
        Status: { propName: 'Status', name: 'Status', order: 2, hidden: false },
        LastModified: { propName: 'LastModified', name: 'Last Modified', order: 3, hidden: false },
    },
];

const KbArticle_FILE_FORMATS = ['CSV', 'XLS', 'XLSX', 'DOC', 'DOCX', 'PDF', 'TXT'];
const KbArticle_MAX_FILE_SIZE_MB = 10;

// options for the inline row-edit Status dropdown
const ROW_STATUS_OPTIONS = [
    { Key: 'Active', Value: 'Active' },
    { Key: 'Inactive', Value: 'Inactive' },
];

// remove this once API implemented
const SAMPLE_TABLE_DATA = [
    {
        Key: 1,
        Filename: 'TEM Invoice Processing Runbook Ver 1.2',
        UploadDate: '07/27/2026 2:15 PM',
        Status: 'Active',
        LastModified: 'Natalie Foster on 07/27/2026 2:15 PM',
    },
    {
        Key: 2,
        Filename: 'TEM Invoice Processing Runbook Ver 1.3',
        UploadDate: '07/27/2026 2:20 PM',
        Status: 'Active',
        LastModified: 'Natalie Foster on 07/27/2026 2:20 PM',
    },
    {
        Key: 3,
        Filename: 'Vendor Onboarding Checklist',
        UploadDate: '07/26/2026 9:05 AM',
        Status: 'Inactive',
        LastModified: 'James Carter on 07/26/2026 9:05 AM',
    },
    {
        Key: 4,
        Filename: 'Monthly Billing Summary June',
        UploadDate: '07/25/2026 4:40 PM',
        Status: 'Active',
        LastModified: 'James Carter on 07/25/2026 4:40 PM',
    },
    {
        Key: 5,
        Filename: 'Credit Note Template',
        UploadDate: '07/24/2026 11:10 AM',
        Status: 'Pending',
        LastModified: 'Natalie Foster on 07/24/2026 11:10 AM',
    },
    {
        Key: 6,
        Filename: 'Vendor Contract Renewal Notice',
        UploadDate: '07/23/2026 3:30 PM',
        Status: 'Active',
        LastModified: 'Olivia Bennett on 07/23/2026 3:30 PM',
    },
    {
        Key: 7,
        Filename: 'Invoice Discrepancy Report',
        UploadDate: '07/22/2026 1:15 PM',
        Status: 'Inactive',
        LastModified: 'Olivia Bennett on 07/22/2026 1:15 PM',
    },
    {
        Key: 8,
        Filename: 'TEM Invoice Processing Runbook Ver 1.4',
        UploadDate: '07/21/2026 10:50 AM',
        Status: 'Active',
        LastModified: 'James Carter on 07/21/2026 10:50 AM',
    },
    {
        Key: 9,
        Filename: 'Quarterly Spend Analysis',
        UploadDate: '07/20/2026 8:25 AM',
        Status: 'Active',
        LastModified: 'Natalie Foster on 07/20/2026 8:25 AM',
    },
    {
        Key: 10,
        Filename: 'Vendor Rate Card Update',
        UploadDate: '07/19/2026 2:05 PM',
        Status: 'Pending',
        LastModified: 'Olivia Bennett on 07/19/2026 2:05 PM',
    },
    {
        Key: 11,
        Filename: 'Billing Agent Configuration Notes',
        UploadDate: '07/18/2026 9:45 AM',
        Status: 'Active',
        LastModified: 'James Carter on 07/18/2026 9:45 AM',
    },
    {
        Key: 12,
        Filename: 'Invoice Extraction Error Log',
        UploadDate: '07/17/2026 5:15 PM',
        Status: 'Inactive',
        LastModified: 'Natalie Foster on 07/17/2026 5:15 PM',
    },
    {
        Key: 13,
        Filename: 'TEM Invoice Processing Runbook Ver 1.5',
        UploadDate: '07/16/2026 12:00 PM',
        Status: 'Active',
        LastModified: 'Olivia Bennett on 07/16/2026 12:00 PM',
    },
    {
        Key: 14,
        Filename: 'Vendor Compliance Checklist',
        UploadDate: '07/15/2026 3:55 PM',
        Status: 'Pending',
        LastModified: 'James Carter on 07/15/2026 3:55 PM',
    },
    {
        Key: 15,
        Filename: 'Credit Note Reconciliation Report',
        UploadDate: '07/14/2026 10:30 AM',
        Status: 'Active',
        LastModified: 'Natalie Foster on 07/14/2026 10:30 AM',
    },
];

const KyberProcAgentForm = ({ kyberAgentEnabled }) => {
    const dispatch = useDispatch();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [enableAgent, setEnableAgent] = useState(false);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [selectedSmartPick, setSelectedSmartPick] = useState('');
    const [kbArticle, setKbArticle] = useState('');
    const [dataTable, setDataTable] = useState([
        {
            HeaderItem: SAMPLE_TABLE_HEADER,
            dataItem: [],
        },
    ]);
    const [savedDataTable, setSavedDataTable] = useState([
        {
            HeaderItem: SAMPLE_TABLE_HEADER,
            dataItem: [],
        },
    ]);
    const [enableEdit, setEnableEdit] = useState(false);
    const [keyIndex, setKeyIndex] = useState(null);
    const [editedRowValues, setEditedRowValues] = useState({});    
    const [addedArticles, setAddedArticles] = useState([]);
    const [articleUpdates, setArticleUpdates] = useState([]);
    const [deletedArticleIds, setDeletedArticleIds] = useState([]);
    const [pendingFiles, setPendingFiles] = useState({});
    const [
        pendingUploadArticles,
        setPendingUploadArticles
    ] = useState([]);
    const [
        isKyberProcProcessing,
        setIsKyberProcProcessing
    ] = useState(false);

    const [
        kyberProcNotification,
        setKyberProcNotification
    ] = useState({
        show: false,
        title: '',
        message: '',
    });
    const [savedFormSnapshot, setSavedFormSnapshot] = useState({
        enableAgent: false,
        selectedRoles: [],
        selectedSmartPick: '',
    });
    const tabberButtonRef = useRef(null);
    const uploadButtonRef = useRef(null);
    const { locale } = useSelector(state => state.translation);
    const {
        roleOptions = [],
        selectedRoleIds: kyberAgentSelectedRoleIds = []
    } = useSelector(
        state => state.kyberConfig ?? {}
    );

    const kyberProcRoleOptions =
        useMemo(() => {

            return Array.isArray(roleOptions)
                ? roleOptions.filter(option =>
                    Array.isArray(
                        kyberAgentSelectedRoleIds
                    ) &&
                    kyberAgentSelectedRoleIds
                        .map(Number)
                        .includes(
                            Number(
                                option?.Key ??
                                option?.key
                            )
                        )
                )
                : [];

        }, [
            roleOptions,
            kyberAgentSelectedRoleIds
        ]);
    const {
        kyberProcAgentConfig = {
            agentEnabled: false,
            smartPickEnabled: false,
            selectedRoleIds: [],
            articles: [],
        },
        isKyberProcAgentLoading = false,
        kyberProcAgentLoadError = null,
        isKyberProcAgentSaving = false,
        kyberProcAgentSaveError = null,
        } = useSelector(
        state => state.kyberConfig ?? {}
        );

    // #region Kyber Proc Initialization
    useEffect(() => {
        dispatch(
            KyberConfigActions.getKyberProcAgentConfig()
        );
    }, [dispatch]);

    useEffect(() => {
        if (!kyberProcAgentConfig) {
            return;
        }

        const loadedAgentEnabled =
            kyberAgentEnabled &&
            kyberProcAgentConfig.agentEnabled === true;

        const loadedSmartPick =
            kyberProcAgentConfig.smartPickEnabled === true
                ? 'true'
                : 'false';

        const loadedRoleIds =
            Array.isArray(
                kyberProcAgentConfig.selectedRoleIds
            )
                ? kyberProcAgentConfig
                    .selectedRoleIds
                    .map(Number)
                    .filter(roleId =>
                        roleId > 0)
                : [];

        const loadedRoles =
            Array.isArray(
                kyberProcRoleOptions
            )
                ? kyberProcRoleOptions
                    .filter(option =>
                        loadedRoleIds.includes(
                            Number(
                                option?.Key ??
                                option?.key
                            )
                        )
                    )
                    .map(option =>
                        option?.Value ??
                        option?.value ??
                        ''
                    )
                    .filter(roleName =>
                        roleName !== ''
                    )
                : [];
        const loadedArticles =
            Array.isArray(
                kyberProcAgentConfig.articles
            )
                ? kyberProcAgentConfig.articles.map(
                    article => {
                        const articleId =
                            article.kyberProcAgentArticleId ??
                            article.KyberProcAgentArticleId ??
                            0;

                        const fileName =
                            article.fileName ??
                            article.FileName ??
                            '';

                        const uploadDateValue =
                            article.uploadDate ??
                            article.UploadDate ??
                            null;

                        const statusValue =
                            article.status ??
                            article.Status ??
                            false;

                        const lastModified =
                            article.lastModified ??
                            article.LastModified ??
                            '';

                        const parsedUploadDate =
                            uploadDateValue
                                ? new Date(uploadDateValue)
                                : null;

                        const formattedUploadDate =
                            parsedUploadDate &&
                                !Number.isNaN(
                                    parsedUploadDate.getTime()
                                )
                                ? parsedUploadDate.toLocaleString(
                                    'en-US',
                                    {
                                        month: '2-digit',
                                        day: '2-digit',
                                        year: 'numeric',
                                        hour: 'numeric',
                                        minute: '2-digit',
                                        hour12: true,
                                    }
                                )
                                : '';

                        return {
                            Key:
                                articleId,

                            KyberProcAgentArticleId:
                                articleId,

                            Filename:
                                fileName,

                            UploadDate:
                                formattedUploadDate,

                            Status:
                                statusValue
                                    ? 'Active'
                                    : 'Inactive',

                            LastModified:
                                lastModified,
                        };
                    }
                )
                : [];

        const loadedDataTable = [
            {
                HeaderItem:
                    SAMPLE_TABLE_HEADER,

                dataItem:
                    loadedArticles,
            },
        ];

        setEnableAgent(
            loadedAgentEnabled
        );

        setSelectedRoles(
            loadedRoles
        );

        setSelectedSmartPick(
            loadedSmartPick
        );

        setDataTable(
            loadedDataTable
        );

        setSavedDataTable(
            loadedDataTable
        );

        setSavedFormSnapshot({
            enableAgent: loadedAgentEnabled,
            selectedRoles: loadedRoles,
            selectedSmartPick: loadedSmartPick,
        });
        setAddedArticles([]);
        setArticleUpdates([]);
        setDeletedArticleIds([]);
        if (
            pendingUploadArticles.length === 0
        ) {
            setPendingFiles({});
        }
        setEditedRowValues({});
        setEnableEdit(false);
        setKeyIndex(null);
    }, [
        kyberProcAgentConfig,
        kyberProcRoleOptions,
        kyberAgentEnabled,
    ]);

    useEffect(() => {
        if (
            kyberAgentEnabled !== false ||
            isKyberProcAgentLoading
        ) {
            return;
        }

        setEnableAgent(
            false
        );

        setEditedRowValues({});
        setEnableEdit(false);
        setKeyIndex(null);
        setKbArticle('');

        uploadButtonRef.current
            ?.setUploadFileName('');
    }, [
        kyberAgentEnabled,
        isKyberProcAgentLoading,
    ]);
    // #endregion
    const clearPendingChanges = () => {
        setAddedArticles([]);
        setArticleUpdates([]);
        setDeletedArticleIds([]);
        setPendingFiles({});
        setEditedRowValues({});
        setEnableEdit(false);
        setKeyIndex(null);
        setPendingUploadArticles([]);
    };
    const showKyberProcNotification = (
        title,
        message
    ) => {
        setKyberProcNotification({
            show: true,
            title,
            message,
        });
    };
    const closeKyberProcNotification = () => {
        setKyberProcNotification({
            show: false,
            title: '',
            message: '',
        });
    };
    const translator = (key, isCapitalize = true) => {
        if (locale === null || locale === '')
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return isCapitalize ? TRANSLATIONS[locale][key]?.toUpperCase() : TRANSLATIONS[locale][key];
    }

    const handleToggle = () => {
        if (
            kyberAgentEnabled === false ||
            isKyberProcBusy
        ) {
            return;
        }

        setIsCollapsed(
            previousValue =>
                !previousValue
        );
    };

    const handleSelectedRoles = (roles) => {
        setSelectedRoles(roles);
    }

    const handleSelectedSmartPick = (fieldProp, value) => {
        setSelectedSmartPick(value);
    }

    const handleCancel = () => {
        setKbArticle('');
        uploadButtonRef.current
            ?.setUploadFileName('');
    };

    const handleClickAddBtn = () => {
        if (!kbArticle) {
            return;
        }

        const uploadedFileData =
            uploadButtonRef.current
                ?.inputFileValue?.() ??
            null;

        if (!uploadedFileData) {
            return;
        }

        const temporaryKey =
            -Date.now();

        const now = new Date().toLocaleString(
            'en-US',
            {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            }
        );

        const newTableArticle = {
            Key:
                temporaryKey,

            TemporaryKey:
                temporaryKey,

            KyberProcAgentArticleId:
                null,

            Filename:
                kbArticle,

            UploadDate:
                now,

            Status:
                'Active',

            LastModified:
                `Current User on ${now}`,

            IsNew:
                true,

            FileData:
                uploadedFileData,
        };

        setDataTable(prev => {
            const currentTable =
                prev?.[0] ?? {
                    HeaderItem:
                        SAMPLE_TABLE_HEADER,
                    dataItem:
                        [],
                };

            return [
                {
                    ...currentTable,
                    dataItem: [
                        ...(currentTable.dataItem ?? []),
                        newTableArticle,
                    ],
                },
            ];
        });

        setAddedArticles(prev => [
            ...prev,
            {
                TemporaryKey:
                    temporaryKey,

                FileName:
                    kbArticle,

                Status:
                    true,
            },
        ]);

        setPendingFiles(prev => ({
            ...prev,
            [temporaryKey]: uploadedFileData,
        }));

        setKbArticle('');

        uploadButtonRef.current
            ?.setUploadFileName('');
    };


    const isKyberProcGloballyDisabled = kyberAgentEnabled === false;
    const isKyberProcFieldsDisabled = isKyberProcGloballyDisabled || !enableAgent;    
    const isAddButtonDisabled = !kbArticle;
    const isSaveButtonDisabled =
        enableAgent &&
        (
            selectedRoles.length === 0 ||
            selectedSmartPick === ''
        );
    const isKyberProcBusy = isKyberProcAgentSaving || isKyberProcProcessing;
    const getNormalizedRoleIds = roles => {
        if (!Array.isArray(roles)) {
            return [];
        }

        const normalizedRoleIds =
            roles
                .map(role => {
                    const directRoleId =
                        role?.Key ??
                        role?.key ??
                        role?.RoleId ??
                        role?.roleId ??
                        role?.Id ??
                        role?.id;

                    const numericRoleId =
                        Number(directRoleId);

                    if (
                        Number.isInteger(
                            numericRoleId
                        ) &&
                        numericRoleId > 0
                    ) {
                        return numericRoleId;
                    }
                    const selectedRoleName =
                        typeof role === 'string'
                            ? role
                            : (
                                role?.Value ??
                                role?.value ??
                                role?.RoleName ??
                                role?.roleName ??
                                role?.Label ??
                                role?.label ??
                                ''
                            );

                    if (!selectedRoleName) {
                        return null;
                    }

                    const matchingOption =
                        kyberProcRoleOptions.find(
                            option =>
                                String(
                                    option?.Value ??
                                    option?.value ??
                                    ''
                                ).trim() ===
                                String(
                                    selectedRoleName
                                ).trim()
                        );

                    const matchedRoleId =
                        Number(
                            matchingOption?.Key ??
                            matchingOption?.key ??
                            matchingOption?.RoleId ??
                            matchingOption?.roleId
                        );

                    return (
                        Number.isInteger(
                            matchedRoleId
                        ) &&
                        matchedRoleId > 0
                    )
                        ? matchedRoleId
                        : null;
                })
                .filter(roleId =>
                    Number.isInteger(roleId) &&
                    roleId > 0
                );

        return [
            ...new Set(
                normalizedRoleIds
            ),
        ].sort(
            (firstRoleId, secondRoleId) =>
                firstRoleId -
                secondRoleId
        );
    };
    const hasKyberProcChanges = useMemo(() => {
        const currentRoles = getNormalizedRoleIds( selectedRoles );
        const savedRoles = getNormalizedRoleIds( savedFormSnapshot.selectedRoles );

        return (
            enableAgent !==
            savedFormSnapshot.enableAgent ||
            selectedSmartPick !==
            savedFormSnapshot.selectedSmartPick ||
            JSON.stringify(currentRoles) !==
            JSON.stringify(savedRoles) ||
            JSON.stringify(
                dataTable[0]?.dataItem ?? []
            ) !==
            JSON.stringify(
                savedDataTable[0]
                    ?.dataItem ?? []
            ) ||
            addedArticles.length > 0 ||
            articleUpdates.length > 0 ||
            deletedArticleIds.length > 0 ||
            pendingUploadArticles.length > 0
        );
    }, [enableAgent, selectedRoles, selectedSmartPick, dataTable, savedDataTable, savedFormSnapshot,
        addedArticles, articleUpdates, deletedArticleIds, pendingUploadArticles,]);

    const handleKbArticle = (fileName) => {
        setKbArticle(fileName);
    }

    const handleClickExtract = () => {
    }

    const handleDeleteRow = (index) => {
        const currentItems =
            dataTable?.[0]?.dataItem ??
            [];

        const sortedItems =
            [...currentItems].sort(
                (firstItem, secondItem) => {
                    const firstDate =
                        new Date(
                            firstItem.UploadDate
                        ).getTime();

                    const secondDate =
                        new Date(
                            secondItem.UploadDate
                        ).getTime();

                    return firstDate - secondDate;
                }
            );

        const itemToDelete =
            sortedItems[index];

        if (!itemToDelete) {
            return;
        }

        const isNewArticle =
            itemToDelete.IsNew === true ||
            Number(
                itemToDelete.TemporaryKey
            ) < 0;

        const temporaryKey =
            itemToDelete.TemporaryKey;

        const articleId =
            Number(
                itemToDelete
                    .KyberProcAgentArticleId
            ) || 0;

        setDataTable(prev => {
            const currentTable =
                prev?.[0] ?? {
                    HeaderItem:
                        SAMPLE_TABLE_HEADER,
                    dataItem:
                        [],
                };

            return [
                {
                    ...currentTable,
                    dataItem:
                        (
                            currentTable.dataItem ??
                            []
                        ).filter(
                            item =>
                                item.Key !==
                                itemToDelete.Key
                        ),
                },
            ];
        });

        if (isNewArticle) {
            setAddedArticles(prev =>
                prev.filter(
                    item =>
                        item.TemporaryKey !==
                        temporaryKey
                )
            );

            setPendingFiles(prev => {
                const updatedFiles = {
                    ...prev,
                };

                delete updatedFiles[
                    temporaryKey
                ];

                return updatedFiles;
            });

            return;
        }

        if (articleId <= 0) {
            return;
        }

        setDeletedArticleIds(prev => [
            ...new Set([
                ...prev,
                articleId,
            ]),
        ]);

        setArticleUpdates(prev =>
            prev.filter(
                item =>
                    item.KyberProcAgentArticleId !==
                    articleId
            )
        );
    };

    const handleUpdateRow = (index) => {
        const currentItems =
            dataTable?.[0]?.dataItem ??
            [];

        const sortedItems =
            [...currentItems].sort(
                (firstItem, secondItem) => {
                    const firstDate =
                        new Date(
                            firstItem.UploadDate
                        ).getTime();

                    const secondDate =
                        new Date(
                            secondItem.UploadDate
                        ).getTime();

                    return firstDate - secondDate;
                }
            );

        const itemToUpdate =
            sortedItems[index];

        if (!itemToUpdate) {
            return;
        }

        const updatedStatus =
            editedRowValues.Status ??
            itemToUpdate.Status;

        const now = new Date().toLocaleString(
            'en-US',
            {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            }
        );

        setDataTable(prev => {
            const currentTable =
                prev?.[0] ?? {
                    HeaderItem:
                        SAMPLE_TABLE_HEADER,
                    dataItem:
                        [],
                };

            return [
                {
                    ...currentTable,
                    dataItem:
                        (
                            currentTable.dataItem ??
                            []
                        ).map(item =>
                            item.Key ===
                                itemToUpdate.Key
                                ? {
                                    ...item,
                                    Status:
                                        updatedStatus,
                                    LastModified:
                                        `Current User on ${now}`,
                                }
                                : item
                        ),
                },
            ];
        });

        const isNewArticle =
            itemToUpdate.IsNew === true ||
            Number(
                itemToUpdate.TemporaryKey
            ) < 0;

        if (isNewArticle) {
            setAddedArticles(prev =>
                prev.map(item =>
                    item.TemporaryKey ===
                        itemToUpdate.TemporaryKey
                        ? {
                            ...item,
                            Status:
                                updatedStatus ===
                                'Active',
                        }
                        : item
                )
            );
        } else {
            const articleId =
                Number(
                    itemToUpdate
                        .KyberProcAgentArticleId
                ) || 0;

            if (articleId > 0) {
                setArticleUpdates(prev => [
                    ...prev.filter(
                        item =>
                            item
                                .KyberProcAgentArticleId !==
                            articleId
                    ),
                    {
                        KyberProcAgentArticleId:
                            articleId,

                        Status:
                            updatedStatus ===
                            'Active',
                    },
                ]);
            }
        }

        setEditedRowValues({});
        setEnableEdit(false);
        setKeyIndex(null);
    };

    const handleEnableEdit = (enable, index) => {
        setEnableEdit(enable);
        setKeyIndex(index);
        if (!enable) {
            setEditedRowValues({});
        }
    }

    const handleRowFieldChange = (propName, e) => {
        const value = e.target.value;
        setEditedRowValues(prev => ({ ...prev, [propName]: value }));
    }

    const handleFileDownload = async (item) => {
        if (!item) {
            return;
        }

        if (item.FileData) {
            const fileUrl =
                window.URL.createObjectURL(
                    item.FileData
                );

            const link =
                document.createElement('a');

            link.href =
                fileUrl;

            link.download =
                item.Filename ||
                item.FileData.name ||
                'KyberProc-KB-Article';

            document.body.appendChild(
                link
            );

            link.click();

            document.body.removeChild(
                link
            );

            window.URL.revokeObjectURL(
                fileUrl
            );

            return;
        }

        const articleId =
            Number(
                item.KyberProcAgentArticleId
            ) || 0;

        if (articleId <= 0) {
            window.alert(
                'The selected Kyber Proc article does not have a valid article ID.'
            );

            return;
        }

        const response =
            await dispatch(
                KyberConfigActions
                    .downloadKyberProcArticle(
                        articleId
                    )
            );

        if (!response) {
            window.alert(
                'Unable to download the selected Kyber Proc article.'
            );

            return;
        }

        if (response.ok === false) {
            let errorMessage =
                response.statusText ||
                'Unable to download the selected Kyber Proc article.';

            try {
                const errorBody =
                    await response.json();

                if (
                    typeof errorBody ===
                    'string'
                ) {
                    errorMessage =
                        errorBody;
                } else {
                    errorMessage =
                        errorBody?.message ||
                        errorBody?.Message ||
                        errorMessage;
                }
            } catch {
                /*
                 * Keep the available status text when the
                 * error response does not contain JSON.
                 */
            }

            window.alert(
                errorMessage
            );

            return;
        }

        const fileBlob =
            await response.blob();

        const fileUrl =
            window.URL.createObjectURL(
                fileBlob
            );

        const link =
            document.createElement('a');

        link.href =
            fileUrl;

        link.download =
            item.Filename ||
            'KyberProc-KB-Article';

        document.body.appendChild(
            link
        );

        link.click();

        document.body.removeChild(
            link
        );

        window.URL.revokeObjectURL(
            fileUrl
        );
    };    

    const sortedDataTable = useMemo(() => {
        const currentItems = dataTable[0]?.dataItem ?? [];

        const sortedItems = [...currentItems].sort((a, b) => {
            const firstDate = new Date(a.UploadDate).getTime();
            const secondDate = new Date(b.UploadDate).getTime();

            return firstDate - secondDate;
        });

        return [
            {
                ...dataTable[0],
                dataItem: sortedItems,
            },
        ];
    }, [dataTable]);

    const handleFormCancel = () => {
        setEnableAgent(
            savedFormSnapshot.enableAgent
        );

        setSelectedRoles(
            savedFormSnapshot.selectedRoles
        );

        setSelectedSmartPick(
            savedFormSnapshot.selectedSmartPick
        );

        setKbArticle('');

        uploadButtonRef.current
            ?.setUploadFileName('');

        setDataTable([
            {
                ...savedDataTable[0],
                dataItem: [
                    ...(
                        savedDataTable[0]
                            ?.dataItem ??
                        []
                    ),
                ],
            },
        ]);

        clearPendingChanges();

        setIsCollapsed(false);
    };

    const uploadPendingKyberProcArticles =
        async mappings => {
            const validMappings =
                Array.isArray(mappings)
                    ? mappings
                    : [];

            const failedUploads = [];

            const remainingFiles = {
                ...pendingFiles,
            };

            for (
                const mapping of validMappings
            ) {
                const temporaryKey =
                    Number(
                        mapping.TemporaryKey
                    );

                const articleId =
                    Number(
                        mapping
                            .KyberProcAgentArticleId
                    );

                const file =
                    remainingFiles[
                    temporaryKey
                    ];

                if (
                    !file ||
                    articleId <= 0
                ) {
                    failedUploads.push({
                        TemporaryKey:
                            temporaryKey,

                        KyberProcAgentArticleId:
                            articleId,

                        Message:
                            'The pending physical file could not be matched to its SQL article.',
                    });

                    continue;
                }

                let uploadResponse;

                try {
                    uploadResponse =
                        await dispatch(
                            KyberConfigActions
                                .uploadKyberProcArticle(
                                    articleId,
                                    file
                                )
                        );
                } catch (error) {
                    failedUploads.push({
                        TemporaryKey:
                            temporaryKey,

                        KyberProcAgentArticleId:
                            articleId,

                        Message:
                            error?.message ||
                            'The Kyber Proc article upload failed.',
                    });

                    continue;
                }

                const uploadSuccess =
                    uploadResponse?.success ===
                    true ||
                    uploadResponse?.Success ===
                    true;

                if (!uploadSuccess) {
                    failedUploads.push({
                        TemporaryKey:
                            temporaryKey,

                        KyberProcAgentArticleId:
                            articleId,

                        Message:
                            uploadResponse
                                ?.message ||
                            uploadResponse
                                ?.Message ||
                            'The Kyber Proc article upload failed.',
                    });

                    continue;
                }

                delete remainingFiles[
                    temporaryKey
                ];
            }

            const failedMappings =
                validMappings.filter(
                    mapping =>
                        failedUploads.some(
                            failed =>
                                Number(
                                    failed
                                        .TemporaryKey
                                ) ===
                                Number(
                                    mapping
                                        .TemporaryKey
                                )
                        )
                );

            setPendingFiles(
                remainingFiles
            );

            setPendingUploadArticles(
                failedMappings
            );

            return {
                Success:
                    failedUploads.length === 0,

                FailedUploads:
                    failedUploads,

                FailedMappings:
                    failedMappings,
            };
        };

    const handleClickSaveBtn = async () => {
        if (
            isKyberProcProcessing ||
            isKyberProcAgentSaving
        ) {
            return;
        }

        setIsKyberProcProcessing(
            true
        );
        const selectedRoleIds =
            getNormalizedRoleIds(
                selectedRoles
            );
        if (
            enableAgent &&
            selectedRoleIds.length === 0
        ) {
            setIsKyberProcProcessing(
                false
            );
            showKyberProcNotification(
                'Kyber Proc Save Failed',
                'The selected roles could not be resolved. Please reselect at least one role and try again.'
            );
            return;
        }
        try {            
            if (
                pendingUploadArticles.length >
                0
            ) {
                const retryResult =
                    await uploadPendingKyberProcArticles(
                        pendingUploadArticles
                    );

                if (!retryResult.Success) {
                    const firstFailure =
                        retryResult
                            .FailedUploads[0];

                    showKyberProcNotification(
                        'Kyber Proc Upload Incomplete',
                        `${retryResult
                            .FailedUploads
                            .length
                        } article upload(s) are still pending. ${firstFailure
                            ?.Message ||
                        'Please try again.'
                        }`
                    );

                    return;
                }

                await dispatch(
                    KyberConfigActions
                        .getKyberProcAgentConfig()
                );

                showKyberProcNotification(
                    'Kyber Proc Save Successful',
                    'The pending Kyber Proc article files were uploaded successfully.'
                );

                return;
            }

            const saveResponse =
                await dispatch(
                    KyberConfigActions
                        .saveKyberProcAgent(
                            enableAgent,
                            selectedSmartPick === 'true',
                            getNormalizedRoleIds(
                                selectedRoles
                            ),
                            addedArticles,
                            articleUpdates,
                            deletedArticleIds
                        )
                );

            const saveSuccess =
                saveResponse?.success ===
                true ||
                saveResponse?.Success ===
                true;

            if (!saveSuccess) {
                showKyberProcNotification(
                    'Kyber Proc Save Failed',
                    saveResponse?.message ||
                    saveResponse?.Message ||
                    kyberProcAgentSaveError ||
                    'The Kyber Proc changes could not be saved.'
                );

                return;
            }

            const addedArticleResults =
                saveResponse?.addedArticles ??
                saveResponse?.AddedArticles ??
                [];

            const normalizedMappings =
                Array.isArray(
                    addedArticleResults
                )
                    ? addedArticleResults
                        .map(result => ({
                            TemporaryKey:
                                Number(
                                    result
                                        .temporaryKey ??
                                    result
                                        .TemporaryKey
                                ),

                            KyberProcAgentArticleId:
                                Number(
                                    result
                                        .kyberProcAgentArticleId ??
                                    result
                                        .KyberProcAgentArticleId
                                ),
                        }))
                        .filter(mapping =>
                            mapping.TemporaryKey <
                            0 &&
                            mapping
                                .KyberProcAgentArticleId >
                            0
                        )
                    : [];

            setAddedArticles([]);
            setArticleUpdates([]);
            setDeletedArticleIds([]);

            setPendingUploadArticles(
                normalizedMappings
            );

            if (
                normalizedMappings.length ===
                0
            ) {
                setPendingUploadArticles([]);
                setPendingFiles({});

                await dispatch(
                    KyberConfigActions
                        .getKyberProcAgentConfig()
                );

                showKyberProcNotification(
                    'Kyber Proc Save Successful',
                    'The Kyber Proc changes were saved successfully.'
                );

                return;
            }

            const uploadResult =
                await uploadPendingKyberProcArticles(
                    normalizedMappings
                );

            if (!uploadResult.Success) {
                const firstFailure =
                    uploadResult
                        .FailedUploads[0];

                showKyberProcNotification(
                    'Kyber Proc Partially Saved',
                    `The SQL changes were saved, but ${uploadResult
                        .FailedUploads
                        .length
                    } article upload(s) failed. Click Save again to retry only the failed upload(s). ${firstFailure
                        ?.Message ||
                    ''
                    }`
                );

                return;
            }

            setPendingUploadArticles([]);
            setPendingFiles({});

            await dispatch(
                KyberConfigActions
                    .getKyberProcAgentConfig()
            );

            showKyberProcNotification(
                'Kyber Proc Save Successful',
                'The Kyber Proc changes and article files were saved successfully.'
            );
        } catch (error) {
            console.error(
                'Kyber Proc save processing failed:',
                error
            );

            showKyberProcNotification(
                'Kyber Proc Save Failed',
                error?.message ||
                'An unexpected error occurred while saving the Kyber Proc changes.'
            );
        } finally {
            setIsKyberProcProcessing(
                false
            );
        }
    };

    return (
        <div className="kyberconfig-form-container">
            <CustomDropdown
                activeDropdown={isCollapsed}
                toggleActiveState={handleToggle}
                label={
                    translator(
                        'kyber_proc_agent',
                        false
                    )
                }
                toggleStatus={enableAgent}
            >
            <div className="kyberconfig-form-content">
                <div className="kyberconfig-toggle-row">
                        <TabberButton
                            ref={tabberButtonRef}
                            title="ENABLE AGENT"
                            value={enableAgent}
                            disabled={isKyberProcGloballyDisabled}
                            onToggle={(isActive) => {
                                if (isKyberProcGloballyDisabled) {
                                    return;
                                }

                                setEnableAgent(isActive);

                                if (!isActive) {
                                    setKbArticle('');
                                    setEditedRowValues({});
                                    setEnableEdit(false);
                                    setKeyIndex(null);
                                    uploadButtonRef.current?.setUploadFileName('');
                                }
                            }}
                        />
                        <CustomMultiSelect
                            options={kyberProcRoleOptions}
                            displayMaxLength={255}
                            label={translator('roles_enabled', false)}
                            placeholder={translator('select_placeholder', false)}
                            requiredField={true}
                            isDisabled={isKyberProcFieldsDisabled}
                            fieldProps="kyberProcAgentForm.ListIds"
                            onChange={handleSelectedRoles}
                            selectedOptions={selectedRoles}
                        />
                    <Select
                        className="form-select required"
                        label={translator('smart_pick')}
                        value={selectedSmartPick}
                        options={SMART_PICK_OPTIONS}
                        placeholder={translator('select_placeholder', false)}
                        fieldProp='kyberProcAgentForm.smartPickID'
                        onChangeAction={handleSelectedSmartPick}
                        disabled={isKyberProcFieldsDisabled}
                    />
                </div>
                    <UploadButton
                        ref={uploadButtonRef}
                        onChange={handleKbArticle}
                        onClickExtract={handleClickExtract}
                        title={"UPLOAD KB ARTICLE"}
                        isReadAndWrite={true}
                        isReadOnly={false}
                        isDisabled={
                            isKyberProcFieldsDisabled ||
                            isKyberProcBusy
                        }
                        fileFormat={KbArticle_FILE_FORMATS}
                        fileSizeMB={KbArticle_MAX_FILE_SIZE_MB}
                        errorModalTitle="Error"
                        clearConfirmationMessage="A KB Article is currently uploaded. Proceed on clearing the file?"
                        allowReplaceExistingFile={true}
                        replaceConfirmationMessage="A KB Article is currently uploaded. Uploading another will disregard the current file. Continue?"
                    />
                <div className="add-button-container custom-add-button">
                    <div className="btn-tooltiptext">
                            <Button
                                variant="outline-secondary"
                                className="btn-custom-violet-hover-outline"
                                disabled={
                                    isKyberProcFieldsDisabled ||
                                    isKyberProcBusy
                                }
                                onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                        {/* <span className="tooltip-text">{<Translation translationKey="" />}</span> */}
                    </div>

                    <div className={'btn-tooltiptext'}>
                        <Button
                            disabled={
                                isKyberProcFieldsDisabled ||
                                isAddButtonDisabled ||
                                isKyberProcBusy
                            }
                            onClick={handleClickAddBtn}
                            variant="primary"
                            className="btn-add"
                        >
                            Add
                        </Button>
                        {/* <span className="tooltip-text"><Translation translationKey="" /></span> */}
                    </div>
                </div>
                <TableWithButton
                        datatable={sortedDataTable}
                        enablePagination={true}
                        haveDeleteBtn={!isKyberProcBusy}
                        haveEditBtn={!isKyberProcBusy}
                        deleteAction={handleDeleteRow}
                        updateAction={handleUpdateRow}
                        searchableDropdownData={[]}
                        inputField={[]}
                        dropdownField={['Status']}
                        dropdownOptionsMap={{ Status: ROW_STATUS_OPTIONS }}
                        optionsMap={[]}
                        downloadableColumn="Filename"
                        onFileDownload={handleFileDownload}
                        selectedItems={editedRowValues}
                        handleSelectChange={() => { }}
                        handleInputChange={handleRowFieldChange}
                        handleOpenNotif={() => { }}
                        handleGetFieldData={() => { }}
                        handelEnableEdit={handleEnableEdit}
                        handleCloseNotif={() => { }}
                        enableEdit={enableEdit}
                        keyIndex={keyIndex}
                        hasError={{}}
                        planComponentError={false}
                        setDefaultError={() => { }}
                />
                <div className="add-button-container custom-add-button justify-content-end">
                    <div className="btn-tooltiptext">
                            <Button
                                variant="outline-secondary"
                                className="btn-custom-violet-hover-outline"
                                disabled={
                                    isKyberProcGloballyDisabled ||
                                    isKyberProcBusy
                                }
                                onClick={handleFormCancel}
                            >
                                Cancel
                            </Button>
                        {/* <span className="tooltip-text">{<Translation translationKey="" />}</span> */}
                    </div>

                    <div className={'btn-tooltiptext'}>
                            <Button
                                disabled={
                                    isKyberProcGloballyDisabled ||
                                    isSaveButtonDisabled ||
                                    !hasKyberProcChanges ||
                                    isKyberProcBusy
                                }
                            onClick={handleClickSaveBtn}
                            variant="primary"
                            className="btn-add"
                            >
                                {isKyberProcBusy
                                    ? 'Processing...'
                                    : pendingUploadArticles.length > 0
                                        ? 'Retry Upload'
                                        : 'Save'}
                        </Button>
                        {/* <span className="tooltip-text"><Translation translationKey="" /></span> */}
                    </div>
                </div>
            </div>

            </CustomDropdown>

            {kyberProcNotification.show && (
                <NotificationModal
                    show={
                        kyberProcNotification.show
                    }
                    title={
                        kyberProcNotification.title
                    }
                    message={
                        kyberProcNotification.message
                    }
                    buttonName="OK"
                    closeButton={true}
                    handleModal={
                        closeKyberProcNotification
                    }
                />
            )}
        </div>
    );
};


export default KyberProcAgentForm;